var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "USERS/Ami ajoute"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.8314 26.7548L28.2598 38.7598L21.5 32M22.8114 26.1379C22.426 25.6699 22.0406 25.2799 21.5782 24.8899C19.497 23.0179 16.7222 21.8479 13.7161 21.8479C7.2414 21.8479 2 27.1519 2 33.7039C2 35.7319 2.53956 37.6819 3.38743 39.3199C3.38743 39.3199 7.70387 36.9019 13.7161 36.9019C15.0264 36.9019 16.1826 36.9799 17.3388 37.2139C18.4179 37.3699 19.4199 37.6039 20.3449 37.8379M20.3447 11.63C20.3447 15.2917 17.4114 18.26 13.793 18.26C10.1745 18.26 7.24121 15.2917 7.24121 11.63C7.24121 7.96835 10.1745 5 13.793 5C17.4114 5 20.3447 7.96835 20.3447 11.63Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonicon);
export default __webpack_public_path__ + "static/media/person.icon.b69340b075b450a925240d17f7608b28.svg";
export { ForwardRef as ReactComponent };